import React from 'react';
import { Pane, Flex, Text } from '@leverege/ui-elements';
import { resetRequestStates } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const VARIANTS = {
  // complete : 'pillSuccess',
  sent: 'pillWarning',
  pending: 'pillWarning'
  // cancelled : 'pillSuccess'
};
export default function ResetRequestState(props) {
  const {
    value,
    defaultValue = null
  } = props;
  if (value == null) {
    return defaultValue;
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: "tableCellContent",
    children: /*#__PURE__*/_jsx(Flex, {
      variant: "rowM",
      style: {
        overflow: 'hidden'
      },
      children: /*#__PURE__*/_jsx(Text, {
        variant: VARIANTS[value] || 'pill',
        children: resetRequestStates[value]
      }, resetRequestStates[value])
    })
  });
}